module.exports = __webpack_public_path__ + "static/media/cx.5dbbd165.svg";